import * as React from "react";
import QueryResult, {
  IQueryResult,
} from "components/organisms/QueryResult/QueryResult";
import { definedCardTypes } from "components/molecules/Cards/EventGridCard";

export interface IframeFilterProps {
  query: IQueryResult;
  onlyEvents?: boolean;
}

const IframeFilter: React.FC<IframeFilterProps> = ({ query, onlyEvents }) => {
  if (query.events.length === 0) return <></>;
  let cardType = definedCardTypes.post;
  if (onlyEvents) {
    cardType = definedCardTypes.calendar;
  }

  return (
    <>
      <QueryResult newTab queryResult={query} cardType={cardType} columns={4} />
    </>
  );
};

export default IframeFilter;
